import { render } from "./simple-modal.vue?vue&type=template&id=462e908f&scoped=true"
import script from "./simple-modal.vue?vue&type=script&lang=js"
export * from "./simple-modal.vue?vue&type=script&lang=js"

import "./simple-modal.vue?vue&type=style&index=0&id=462e908f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-462e908f"]])

export default __exports__